// Web shim to avoid importing @react-navigation/stack's Card implementation,
// which uses deprecated shadow* props on React Native Web.
// This re-exports a compatible factory named createStackNavigator that delegates
// to @react-navigation/native-stack.

const { createNativeStackNavigator } = require('@react-navigation/native-stack');

module.exports = {
  createStackNavigator: createNativeStackNavigator,
};












